import React from 'react';
import Form from 'react-bootstrap/lib/Form';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import InfoPopOver from './InfoPopOver';

export default class CheckboxOrRadioGroup extends React.Component {
  constructor(props) {
    super(props);
    this.otherInput = this.otherInput.bind(this);
    this.title = this.title.bind(this);
  }
  otherInput = ({otherId, otherPlaceholder, otherDefault, controlOther}) => {
    if (controlOther !== undefined &&
        otherPlaceholder !== undefined &&
        otherDefault !== undefined &&
        otherId !== undefined){
      return (
        <FormControl
          id={otherId}
          type="text"
          componentClass="input"
          placeholder={otherPlaceholder}
          defaultValue={otherDefault}
          onChange={controlOther}/>
      );
    } else {
      return(null);
    }
  }
  title = () => {
    if (this.props.title){
      return(
        <ControlLabel>{this.props.title}</ControlLabel>
      )
    }
  }
  render(){
    return (
      <div>
        {
          this.props.options.length > 0 &&
          <FormGroup>
            {this.title()}
            <div className={`${this.props.type}-group`}>
              {this.props.options.map((opt, i) => {
                return (
                  <ControlLabel key={opt[1]} className={this.props.checkBoxStyle ? this.props.checkBoxStyle : `${this.props.type}-inline` } style={{opacity: this.props.disabled ? 0.6 : 1}}>
                    <input
                      className={`form-${this.props.type}`}
                      ref={this.props.setName+"_"+opt[1].split(' ').join('_').toLowerCase()}
                      name={this.props.setName}
                      id={this.props.setName+"_"+opt[1].split(' ').join('_').toLowerCase()}
                      onChange={this.props.controlFunc}
                      value={opt[1]}
                      disabled={this.props.disabled}
                      checked={this.props.selectedOptions.includes(opt[1])}
                      type={this.props.type}
                    />
                    {opt[0]} {this.props.info ? <InfoPopOver popOverText={this.props.info[i]}/> : ''}
                  </ControlLabel>
                );
              })}
              {this.otherInput(this.props)}
            </div>
          </FormGroup>
        }
      </div>
    )
  }
}
